var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
/** A primitive component for text content that conforms to Quinine typography rules. */
export const QuiText = (_a) => {
    var { size = "text-sm", inline, weight = "normal", monospace, as: CustomTag, muted, color, children, ellipsisOverflow, className } = _a, rest = __rest(_a, ["size", "inline", "weight", "monospace", "as", "muted", "color", "children", "ellipsisOverflow", "className"]);
    // attempt some bare-bones semantic markup based on text token
    // note: <p> can only contain inline elements (block elements will cause react validateDomNesting to fail). It's too constricting to use <p> as a default.
    const defaultBlockTag = "div";
    const defaultInlineTag = weight && weight !== "normal" ? "strong" : "span";
    const defaultTag = inline ? defaultInlineTag : defaultBlockTag;
    const prefixedSize = monospace ? `mono-${size}` : size;
    const RootTag = CustomTag !== null && CustomTag !== void 0 ? CustomTag : defaultTag;
    const cn = classNames(className, {
        "qui-bold": weight === "bold",
        "qui-semibold": weight === "medium",
        "qui-d-inline": inline, // makes the inline prop work when block tags are specified
        "qui-text-muted": muted,
        "qui-ellipsis-overflow": ellipsisOverflow,
        [`qui-color-${color}`]: !!color,
    }, `qui-${prefixedSize}`, "qui-reset-text");
    return (React.createElement(RootTag, Object.assign({ className: cn }, rest), children));
};
